"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _usePrefersColorScheme = _interopRequireDefault(require("./use-prefers-color-scheme"));
var _default = _usePrefersColorScheme["default"];
exports["default"] = _default;